import React from "react";
import { Link } from "react-router-dom";
import CategoryDropdown from "./CategoryDropdown";
import Subscriptions from "./Subscriptions";

function Footer({ cart }) {
  return (
    <footer className="bg-gray-900 text-gray-100 p-10">
      <div className="container mx-auto grid grid-cols-1 gap-6 md:grid-cols-3">
        {/* Column 1: Branding and Newsletter */}
        <div>
          <Link to="/" className="flex items-center gap-2 text-2xl font-extrabold">
            <img src="https://proprimemart.com/237mechanic_real_logo.png" alt="237Mechanic Logo" className="h-20 w-auto" />
          </Link>
          <p className="mt-4 text-lg">
            Your trusted partner for premium automobile solutions in Cameroon.
            Brand new and fairly used cars, spare car parts, lubricants, tyres, and much more.
            Email:info@237mechanic.com, phone: +237672602782
          </p>
          <Subscriptions/>
        </div>

        {/* Column 2: Company & Support Navigation */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <nav>
            <h6 className="footer-title text-xl font-bold mb-2">Company</h6>
            <Link to="/" className="block p-2 hover:underline">Home</Link>
            <Link to="/about-us" className="block p-2 hover:underline">About Us</Link>
            <Link to="/contact-us" className="block p-2 hover:underline">Contact</Link>
            <Link to="/shop" className="block p-2 hover:underline">Shop</Link>
            <CategoryDropdown />
          </nav>
          <nav>
            <h6 className="footer-title text-xl font-bold mb-2">Support</h6>
            <Link to="/faq" className="block p-2 hover:underline">FAQ</Link>
            <Link to="/mechanics" className="block p-2 hover:underline">Find a mechanic</Link>
            <Link to="/car-rentals" className="block p-2 hover:underline">Car rentals</Link>
            <Link to="/car-servicing" className="block p-2 hover:underline">Car Servicing</Link>
            <Link to="/car-importation-consultation" className="block p-2 hover:underline">Car Importation Consulting</Link>
            <Link to="/work-with-us" className="block p-2 hover:underline">Work With us</Link>
            <Link to="/articles" className="block p-2 hover:underline">Knowledge base</Link>
            <Link to="/terms-and-conditions" className="block p-2 hover:underline">Terms and Conditions</Link>
          </nav>
        </div>

      
        <div>
          <nav>
            <h6 className="footer-title text-xl font-bold mb-2">Legal</h6>
            <p className="text-sm mb-4">
              Before booking a service or an appointment do well to read our Terms and Conditions first.
            </p>
            <p className="text-sm">© {new Date().getFullYear()} 237Mechanic. All rights reserved.</p>
            <div className="mt-4">
             
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
